/**
 * CMCD `query` transmission mode.
 *
 *
 * @beta
 */
export const CMCD_QUERY = 'query'
